import StudentTabsHeader from '../StudentTabsHeader';
import { Col } from 'reactstrap';
import { useState, useMemo } from 'react';
import { isNumber } from '../../../../utils/math';
import { useParams } from 'react-router-dom';
import { PetitionsHistoryLoader } from './parts/PetitionsHistoryLoader';
import { PetitionsTable } from './parts/PetitionsTable';
import { Modal } from '@octano/global-ui';
import { PetitionDetailModal } from './parts/petitionDetailModal';
import { Pagination } from './types';

export function RequestsHistory() {
  const { studentId } = useParams<{ studentId: string }>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    items_per_page: 10,
  });
  const [modalPetitionId, setModalPetitionId] = useState<number>();
  const studentIdInt = useMemo(() => {
    if (isNumber(studentId)) {
      return Number(studentId);
    }
    return null;
  }, [studentId]);
  if (!studentIdInt) {
    throw new Error('Invalid postulantId');
  }

  function openModal(petitionId: number) {
    setModalPetitionId(petitionId);
    setIsModalOpen(true);
  }

  return (
    <>
      <PetitionsHistoryLoader studentId={studentIdInt} pagination={pagination}>
        {({ data }, query, updateQuery) => (
          <>
            <StudentTabsHeader
              id={data.student.rut}
              name={data.student.fullName}
            />
            <Col className="my-5">
              <PetitionsTable
                petitions={data.petitions}
                openModal={openModal}
                query={query}
                updateQuery={updateQuery}
                setPagination={setPagination}
              />
            </Col>
            <Modal
              isOpen={isModalOpen}
              size="xl"
              toggle={() => {
                setIsModalOpen(false);
                setModalPetitionId(undefined);
              }}
              children={
                <PetitionDetailModal
                  petitionId={modalPetitionId}
                  onClose={() => setIsModalOpen(false)}
                />
              }
            />
          </>
        )}
      </PetitionsHistoryLoader>
    </>
  );
}
